import { useState, useEffect, } from "react";
import { useTranslation } from "react-i18next";
// import moment from "moment";
import LoadingComponent from "./loading-component";
import { obtenerAllInfoVehiculo } from "../api/api-vehiculo";
import { allInfoInstalacion } from "../api/api-instalacion";
// import momentLocalizer from "react-widgets-moment";

// new momentLocalizer(moment);

export default function ModalInfoInstalacion({ title, idActivo, isOpen, onClose }) {

    const { t } = useTranslation();

    const [infoVehiculo, setInfoVehiculo] = useState({});
    const [infoInstalacion, setInfoInstalacion] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // if (idActivo !== null) {
        iniciar();
        // }
        // setLoading(false);
    }, [idActivo]);

    const iniciar = async () => {
        try {
            setLoading(true);
            console.log('ModalInfoInstalacion', idActivo);
            if (idActivo !== null) {
                const info = await obtenerAllInfoVehiculo({ idActivo });
                // console.log('info', info);
                setInfoVehiculo(info);
                const instalacion = await allInfoInstalacion({ idActivo });
                // console.log('instalacion', instalacion);
                setInfoInstalacion(instalacion);
            }
            setLoading(false);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
        }
    };

    if (loading === true) {
        return (
            <LoadingComponent
                isOpen={true}
            />
        );
    }

    return (
        <>
            {isOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 pt-36 overflow-y-auto">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-full mx-4">
                        <h2 className="text-xl font-bold mb-4 text-gray-700">{title}: {idActivo}</h2>

                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <div>
                                    <label>{t("label_company")}:</label>
                                    <input
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        type="text"
                                        value={infoVehiculo?.idEmpresaPlataforma}
                                        readOnly={true}
                                    />
                                </div>
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>&nbsp;</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoVehiculo?.empresaPlataforma}
                                    readOnly={true}
                                />
                            </div>
                        </div>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <div>
                                    <label>{t("label_name_activo")}:</label>
                                    <input
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        type="text"
                                        value={infoVehiculo?.nombre}
                                        readOnly={true}
                                    />
                                </div>
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>{t("label_vehicle")}:</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoVehiculo?.idActivo}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>{t("label_date_install")}:</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoInstalacion?.fechaInstalacion}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>{t("label_date_uninstall")}:</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoInstalacion?.fechaDesinstalacion}
                                    readOnly={true}
                                />
                            </div>
                        </div>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>{t("label_grupo")}</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoVehiculo?.grupo}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>{t("label_subgrupo")}</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoVehiculo?.subgrupo}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>{t("label_order_install")}:</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoVehiculo?.ordenTrabajoInstalacion}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>{t("label_order_uninstall")}:</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoVehiculo?.ordenTrabajoDesinstalacion}
                                    readOnly={true}
                                />
                            </div>
                        </div>
                        <br />
                        <hr />
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>ESN:</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoInstalacion?.idEquipo}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>IMEI:</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoInstalacion?.imeiEquipo}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>{t("label_device_provider")}</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoInstalacion?.proveedorEquipo}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>{t("label_model_device")}</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoInstalacion?.modelo}
                                    readOnly={true}
                                />
                            </div>
                        </div>
                        <br />
                        <hr />
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>SIM</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoInstalacion?.linea}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>ICCID</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoInstalacion?.iccid}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>{t("label_sim_provider")}</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoInstalacion?.operadorTelefonica}
                                    readOnly={true}
                                />
                            </div>
                        </div>
                        <br />
                        <hr />
                        <label className="font-bold">{t("label_info_vehiculo")}</label>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>{t("label_tipo_vehiculo")}</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoVehiculo?.tipoVehiculo}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>{t("label_marca")}</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoVehiculo?.marca}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>{t("label_model")}</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoVehiculo?.modelo}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>Color</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoVehiculo?.colorVehiculo}
                                    readOnly={true}
                                />
                            </div>
                        </div>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>Version</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoVehiculo?.anio}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>{t("label_numero_chasis")}</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoVehiculo?.nroChasis}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>{t("label_numero_motor")}</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoVehiculo?.motor}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>{t("label_cilindrada")}</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoVehiculo?.motor}
                                    readOnly={true}
                                />
                            </div>
                        </div>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>{t("label_tipo_combustible")}</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoVehiculo?.tipoCombustible}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>{t("label_capacidad_tanque")}</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoVehiculo?.capacidadTanque}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>{t("label_capacidad_carga")}</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoVehiculo?.capacidadCarga}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>{t("label_capacidad_volumen")}</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoVehiculo?.capacidadVolumen}
                                    readOnly={true}
                                />
                            </div>
                        </div>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>{t("label_voltaje_bateria")}</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoVehiculo?.voltajeBateria}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label>{t("label_traccion")}</label>
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoVehiculo?.traccion}
                                    readOnly={true}
                                />
                            </div>
                        </div>
                        <br />
                        <hr />
                        <label className="font-bold">{t("label_seller")}</label>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                {/* <label>{t("label_seller")}</label> */}
                                <input
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    type="text"
                                    value={infoInstalacion?.vendedor}
                                    readOnly={true}
                                />
                            </div>
                        </div>
                        <br />
                        {/* Buttons */}
                        <div className="flex justify-end gap-4">
                            <button
                                onClick={onClose}
                                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500 transition duration-300"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );

}
